import React, { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import IntlMessages from "../../util/IntlMessages";
import { Button, Row, Col, Divider, Popover } from "antd";
import {
  loadIsPromoCodePopoverVisible,
  loadIsTaxPopoverVisible,
  loadIsPromotionPopoverVisible,
  loadIsDiscountPopoverVisible,
  loadIsPaymentPopoverVisible,
} from "../../appRedux/actions/MainSale";
import { formatDigits } from "../../appRedux/actions";

const PaymentProcess = (props) => {
  const dispatch = useDispatch();

  const getCurrData = props.getCurrData
    ? props.getCurrData
    : {
      currencyCode: "",
      currencyName: "",
      currencySymbol: "",
    };
  const getIsSalePaymentProcessStart = useSelector(
    ({ MainSale }) => MainSale.getIsSalePaymentProcessStart
  );
  const getDefaultDecimalPlaces = useSelector(
    ({ MainSale }) => MainSale.getDefaultDecimalPlaces
  );
  const getIsPaymentPopoverVisible = useSelector(
    ({ MainSale }) => MainSale.getIsPaymentPopoverVisible
  );
  const getSalePayments = useSelector(
    ({ MainSale }) => MainSale.getSalePayments
  );

  const paymentTitle = (
    <p className="custom-font-size-weight custom-font-color-black dk-pt3 dk-mgb-10">
      <IntlMessages id="sell.sell.payment" />
    </p>
  );
  const paymentContent = (
    <div className="dk-mgt-3">
      {getSalePayments &&
        getSalePayments.map((paymentObj) => {
          return (
            <>
              <Row>
                <Col md={16} xs={12}>
                  {/* //sale-total-line-item--sub */}
                  <div className=" custom-inline">
                    <p className="custom-font-size-weight custom-inline  ">
                      {paymentObj.paymentName}
                    </p>
                    <div className="dk-text-supplementary">
                      {paymentObj.paymentDate ? paymentObj.paymentDate : ""}
                    </div>
                  </div>
                </Col>

                <Col md={8} xs={12} className="custom-pd-left0 custom-pd-right0">
                  <p className="custom-font-size-weight custom-font-color-black">
                    -{" "}
                    {getCurrData.currencyCode != null
                      ? getCurrData.currencyCode
                      : getCurrData.currencyName != null
                        ? getCurrData.currencyName
                        : getCurrData.currencySymbol}
                    {formatDigits(paymentObj.amount, getDefaultDecimalPlaces)}
                  </p>
                </Col>
              </Row>
              <Divider className="custom-payment-divider" />
            </>
          );
        })}
      <div className="dk-flex dk-discount-popover-footer dk-pt3 dk-pb3 ">
        <Button
          className="dk-btn-cancel dk-mgr-8"
          type="primary"
          onClick={() => {
            handlePaymentVisibleChange(false);
          }}
        >
          <IntlMessages id="sell.sell.close" />
        </Button>
      </div>
    </div>
  );

  const handlePaymentVisibleChange = (isPopOverVisible) => {
    // setIsPaymentPopoverVisible(isPopOverVisible);
    dispatch(loadIsPaymentPopoverVisible(isPopOverVisible));
    // setIsPromotionPopoverVisible(false);
    dispatch(loadIsPromotionPopoverVisible(false));
    // setIsDiscountPopoverVisible(false);
    dispatch(loadIsDiscountPopoverVisible(false));
    // setIsTaxPopoverVisible(false);
    dispatch(loadIsTaxPopoverVisible(false));
    // setIsPromoCodePopoverVisible(false);
    dispatch(loadIsPromoCodePopoverVisible(false));
  };

  return (
    getIsSalePaymentProcessStart && (
      <Row className="sale-list-footer-item-1 cart-sl">
        <Col md={16} xs={16} sm={12}>
          <Popover
            placement="left"
            title={paymentTitle}
            content={paymentContent}
            trigger="click"
            visible={getIsPaymentPopoverVisible}
          >
            <p
              className="custom-font-size-weight custom-inline  dk-link"
              onClick={() => {
                handlePaymentVisibleChange(true);
              }}
            >
              <IntlMessages id="sell.sell.payment" />
            </p>
          </Popover>

          <div className="sale-total-line-item--sub custom-inline">
            <p className="custom-font-size-weight custom-inline">
              {getSalePayments && getSalePayments != undefined
                ? getSalePayments.length
                : "No Payments"}{" "}
              <IntlMessages id="sell.sell.paymentmade" />
            </p>
          </div>
        </Col>

        <Col md={8} xs={8} sm={12}>
          <p className="custom-font-size-weight custom-font-color-black text-rite">
            {getCurrData.currencyCode != null
              ? getCurrData.currencyCode
              : getCurrData.currencyName != null
                ? getCurrData.currencyName
                : getCurrData.currencySymbol}{" "}
            {getSalePayments && getSalePayments != undefined
              ? formatDigits(
                getSalePayments
                  .reduce((a, v) => (a = a + v.amount), 0),
                getDefaultDecimalPlaces
              )
              : "0.00"}
          </p>
        </Col>
      </Row>
    )
  );
};

export default PaymentProcess;
